import { render } from "./Circle.vue?vue&type=template&id=a0151968"
import script from "./Circle.vue?vue&type=script&lang=js"
export * from "./Circle.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Circle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a0151968"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a0151968', __exports__)) {
    api.reload('a0151968', __exports__)
  }
  
  module.hot.accept("./Circle.vue?vue&type=template&id=a0151968", () => {
    api.rerender('a0151968', render)
  })

}


export default __exports__